import { useSupportContext } from "@/stores";
import { Send } from "@mui/icons-material";
import { Button, Stack, TextField } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC, FormEvent, useState } from "react";
import { useSendChatMessage, useStartFeedbackChat } from "../../queries";
import { FileInput } from "../file-input";

const ChatFooter: FC = () => {
  const { currentChat } = useSupportContext();
  const [messageValue, setMessageValue] = useState("");

  const { isStartFeedbackChatLoading, startFeedbackChat } =
    useStartFeedbackChat();
  const { sendChatMessage, isSendChatMessageLoading } = useSendChatMessage();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!messageValue || !currentChat) return;

    if (!currentChat.isActive && currentChat.feedback) {
      startFeedbackChat({
        feedbackId: currentChat.feedback?.id,
        response: messageValue,
      });
    }

    if (currentChat.isActive) {
      sendChatMessage({
        chatId: currentChat.id,
        body: messageValue,
        attachments: [],
      });
    }

    setMessageValue("");
  };

  return (
    <form onSubmit={onSubmit} style={{ width: "100%" }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        p={1}
        sx={{ backgroundColor: grey[900] }}
      >
        <FileInput />
        <TextField
          autoComplete="off"
          value={messageValue}
          onChange={({ target: { value } }) => setMessageValue(value)}
          placeholder="Send a message"
        />
        <Button
          type="submit"
          variant="contained"
          endIcon={<Send />}
          disabled={isStartFeedbackChatLoading || isSendChatMessageLoading}
          loading={isStartFeedbackChatLoading || isSendChatMessageLoading}
          sx={{ height: "fit-content" }}
        >
          Send
        </Button>
      </Stack>
    </form>
  );
};

export { ChatFooter };
